import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    ReferenceField,
    BooleanField,
    usePermissions,
    useResourceContext,
    EditButton,
    ShowButton,
    Filter,
    SearchInput,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const UserBranchAccessFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <ReferenceInput 
            source='user_id' 
            reference='user' 
            alwaysOn 
            label="User"
        >
            <SelectInput optionText="username" />
        </ReferenceInput>
        <ReferenceInput 
            source='branch_id' 
            reference='branch' 
            alwaysOn 
            label="Branch"
        >
            <SelectInput optionText="branch_name" />
        </ReferenceInput>
        <SelectInput 
            source='access_level' 
            choices={[
                { id: 'VIEW', name: 'View Only' },
                { id: 'EDIT', name: 'Edit' },
                { id: 'ADMIN', name: 'Admin' },
            ]} 
            label="Access Level"
        />
        <SelectInput 
            source='is_primary_branch' 
            choices={[
                { id: '1', name: 'Yes' },
                { id: '0', name: 'No' },
            ]} 
            label="Primary Branch"
        />
    </Filter>
);

export const UserBranchAccessList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    // Use utility function to process permissions with role-based restrictions
    const propsObj = processPermissions(permissions, resource);
    
    // Enable bulk actions only for admin users (role_id = 1)
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="User Branch Access Management" 
                {...props} 
                {...propsObj}
                filters={<UserBranchAccessFilter />}
                sort={{ field: 'user_id', order: 'ASC' }}
                perPage={25}
            >
                <Datagrid 
                    rowClick={propsObj.hasEdit ? 'edit' : false} 
                    bulkActionButtons={allowBulkActions ? undefined : false}
                >
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <ReferenceField source="user_id" reference="user" label="User">
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField source="branch_id" reference="branch" label="Branch">
                        <TextField source="branch_name" />
                    </ReferenceField>
                    <TextField source="access_level" label="Access Level" />
                    <BooleanField source="is_primary_branch" label="Primary Branch" />
                    <BooleanField source="status" label="Active" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
